module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av358-b4f24998bf33c16024559fbef62f8b03.jpg";